import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user.svg'
import _imports_1 from '@/assets/images/calendar-alt.svg'
import _imports_2 from '@/assets/images/social-sharing-icon/facebook-sharing-icon.svg'
import _imports_3 from '@/assets/images/social-sharing-icon/twitter-sharing-icon.svg'
import _imports_4 from '@/assets/images/social-sharing-icon/linkedin-sharing-icon.svg'
import _imports_5 from '@/assets/images/social-sharing-icon/pinterest-sharing-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a443342e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "blog-detail-section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "blog-detail-content" }
const _hoisted_6 = { class: "white__bg" }
const _hoisted_7 = { class: "blog-image-slider" }
const _hoisted_8 = { class: "blog-image-item" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "blog-auther-date" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_13 = { class: "social-sharing-icons" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "blog-content" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "next-pre-blog clearfix" }
const _hoisted_29 = { class: "previous-blog" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_31 = { class: "next-blog" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_33 = {
  key: 0,
  class: "blog-detail-sidebar"
}
const _hoisted_34 = { class: "related-post" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Related Posts", -1))
const _hoisted_36 = { class: "related-post-list" }
const _hoisted_37 = { class: "related-post--img" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "related-post--content" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_jobForm = _resolveComponent("jobForm")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["blog-detail-inner", { 'full-blog-details': _ctx.allRelatedBlogs.length == 0 }])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.getCdnImageAddress(_ctx.blogData.blogImage, `w_1200,h_627/`),
                      width: "100%",
                      alt: ""
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("h1", null, _toDisplayString(_ctx.blogData.title), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(_ctx.blogData.author), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(_ctx.formattedDate), 1)
                    ]),
                    _createElementVNode("li", _hoisted_13, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.facebookShareUrl,
                            class: "facebook",
                            target: "_blank",
                            rel: "noopener"
                          }, _hoisted_16, 8, _hoisted_14)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.twitterShareUrl,
                            class: "twitter",
                            target: "_blank",
                            rel: "noopener"
                          }, _hoisted_19, 8, _hoisted_17)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.linkedinShareUrl,
                            class: "linkedin",
                            target: "_blank",
                            rel: "noopener"
                          }, _hoisted_22, 8, _hoisted_20)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.pinterestShareUrl,
                            class: "pinterest",
                            target: "_blank",
                            rel: "noopener"
                          }, _hoisted_25, 8, _hoisted_23)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.blogData.description
                  }, null, 8, _hoisted_27)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", _hoisted_29, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.previousBlog && _ctx.previousBlog(...args)), ["prevent"])),
                      href: "#",
                      class: _normalizeClass({ disabled: !_ctx.hasPreviousBlog })
                    }, [
                      _hoisted_30,
                      _createTextVNode(" Previous Blog ")
                    ], 2)
                  ]),
                  _createElementVNode("li", _hoisted_31, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextBlog && _ctx.nextBlog(...args)), ["prevent"])),
                      href: "#",
                      class: _normalizeClass({ disabled: !_ctx.hasNextBlog })
                    }, [
                      _createTextVNode(" Next Blog "),
                      _hoisted_32
                    ], 2)
                  ])
                ])
              ])
            ]),
            (_ctx.allRelatedBlogs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRelatedBlogs.slice(0, 4), (relatedBlog) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "related-post-row clearfix",
                          key: relatedBlog.id
                        }, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("img", {
                              src: _ctx.getCdnImageAddress(relatedBlog.blogImage, `w_90,h_57/`),
                              alt: ""
                            }, null, 8, _hoisted_38)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_router_link, {
                              to: `/blogs/${relatedBlog.slug}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(relatedBlog.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_40
          ], 2)
        ])
      ])
    ]),
    _createVNode(_component_jobForm),
    _createVNode(_component_userFooter)
  ]))
}